import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";
import Autocomplete from "@material-ui/lab/Autocomplete";
//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
	Breadcrumbs,
	Typography,
} from "@material-ui/core";
import { makeStyles, createTheme, MuiThemeProvider} from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import { NavLink } from "react-router-dom";

//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import DeleteUserRole from './DeleteUserRole';
import AddUserRole from './AddUserRole';
import UpdateUserRole from './UpdateUserRole';
import MessageBox from "../../../components/MessageBox/MessageBox";
import UpdatePackageSalesUserRole from "./UpdatePackageSalesUserRole";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));

const UserRole = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: new Date(),
	});
	const classes = useStyles();

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	const [downloadFlag, setDownloadFlag] = useState(false);
	// Data Fetching
	useEffect(() => {
		data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
		dataFilter();
	}, [x]);
	
	//search button
	const dataFilter = async () => {
        const result = await axios.get(
            process.env.REACT_APP_API_URL+'get_user_roles', {
        })
        setPosts(result.data.data);
    }

	const data = async () => {
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};

	const showModal = (message, type) => {
			setShowMsgBox(true);
			setMsgType(type); //success or warning
			setMsg(message);
			dataFilter();
			setTimeout(() => {
				setShowMsgBox(false);
			}, 2000)
	};

	const getMuiTheme = () => createTheme({
		overrides: {
		  MUIDataTableHeadCell: {
			root: {
			  '&:nth-child(1)': {
					width: 800
				  },	
			  '&:nth-child(2)': {
				width: 250
			  },
			}
		  }
		}
	  });

	const columns = [
		{
			name: "position",
			label: "Position",
		},
		{
			name: "position_id",
			label:"Actions",
			options: {
				sort:false, 
				filter: false, 
				customBodyRenderLite: (dataIndex) => {
					let position_id = posts[dataIndex].position_id;
					let position_name = posts[dataIndex].position;
                            return (
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={12} md={5} lg={4} xl={3} key={position_id}>
										   <UpdateUserRole position_id={position_id} position_name={position_name}  showModal={showModal}/>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={5} lg={4} xl={3} key={position_name+position_id}>
											<DeleteUserRole position_id={position_id} position_name={position_name} showModal={showModal}/>
                                    </Grid>
                                </Grid>
                            );
			  },
			  download: false,
			  print: false //exclude this column in csv export
			}
		}
	];

	const options = {
		filter: false,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},   
		download: false,  //add this
		print: false, //add this
		viewColumns :false,
		downloadOptions: {
			filename : 'UserRole.csv' //change filename of csv
		},
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		// marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/settings">
						<h4 className="header-title">Settings</h4>
					</NavLink>
					<Typography color="textPrimary">User Role</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
				<div style={style}>
					<Grid container spacing={1}>
						<Grid item xs={12} xl={12} style={{ display: "flex", justifyContent: "flex-end" }}>
							{/* <Button style ={{marginTop: "22px", marginLeft:"10px"}} variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button> */}
							{/* <Button style ={{marginTop: "22px", marginLeft:"10px"}} variant="contained" color="primary"  onClick={() => {dataFilter()}}>Add Role</Button> */}
							<AddUserRole showModal={showModal}/>
							{/* <NavLink to="/settings/user-access">
							<Button style ={{marginTop: "22px", marginLeft:"10px"}} variant="contained" color="primary">Add Role</Button>
							</NavLink> */}
						</Grid>
					</Grid>       
				</div>
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				{!dataLoaded ? (
					<Preloader />
				) : (
					<MuiThemeProvider theme={getMuiTheme()}>
						<MUIDataTable
							title={
								<div>
									<h3 className="header-title" style={{ color: "#339933"}}>
									User Role
									</h3>
								</div>
							}
							data={posts}
							columns={columns}
							options={options}
						/>
					</MuiThemeProvider>
				)}
			</div>
		</div>
	);
};

export default UserRole;
